export const environment = {
  apiUrl: 'https://dev.api.eyescloud3d.com',
  apiBlogUrl: 'https://api.ecapturedtech.com',
  appUrl: 'https://dev.app.eyescloud3d.com',
  port: 4010,
};
